import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import {
    Box, Grid, GridItem, Text, useDisclosure, Spinner, Center, VStack, HStack, Icon, List, ListItem, ListIcon, Divider,
    Input, InputGroup, InputLeftElement,
    InputRightElement, IconButton, Flex, Select, Badge, useToast, ButtonGroup, Button, Checkbox,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Spacer, Collapse
} from '@chakra-ui/react';
import {
    CalendarIcon, InfoOutlineIcon, CheckCircleIcon, SearchIcon,
    CloseIcon, TimeIcon, WarningIcon, ChevronDownIcon
} from '@chakra-ui/icons';
import { OrderList } from '../components/OrderListDespacho';
import { ConfirmationModalDespacho } from '../components/ConfirmationModalDespacho';
import { ModalEmitirNfeDespacho } from '../components/ModalEmitirNfeDespacho';
import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";

import {
    getProdutosParaConferencia, salvarConferenciaProduto, reverterConferenciaProduto,
    concluirEmbalagemDespacho, reverterEmbalagemDespacho,
    criarObsVenda, apagarObsVenda, setStatusVenda, getCanceladasDespacho, getImagensDivergentes,
    anteciparDespachoVenda
} from '../services/api';
import CardVendaCancelada from '../components/despacho/CardVendaCancelada';
import CardVendaOutroStatus from '../components/despacho/CardVendaOutroStatus';
import EntradaEstoqueProblemaModal from '../components/despacho/EntradaEstoqueProblemaModal';
import CorrigirImagemModal from '../components/despacho/CorrigirImagemModal';
import SecaoImagemDivergente from '../components/despacho/SecaoImagemDivergente';
import BarcodeScanner from '../components/BarcodeScanner';
import { FaCamera } from 'react-icons/fa';
import { useConfirm } from '../components/ConfirmDialog';
import { marcarProntoRetiradaDespacho, marcarRetiradaColetadaDespacho } from '../services/api';
import FiltroMultiplo from '../components/FiltroMultiplo';
import { labelModoEnvio } from '../utils/envioMl';

const ORIGENS_DESPACHO = [
    { valor: 'Estoque TAGA', rotulo: 'Estoque TAGA' },
    { valor: 'Morelate', rotulo: 'Morelate' },
    { valor: 'Vannucci', rotulo: 'Vannucci' },
    { valor: 'BrCompany', rotulo: 'BrCompany' },
    { valor: 'LNG', rotulo: 'LNG' },
    { valor: 'CBA', rotulo: 'CBA' },
    { valor: 'MSAM', rotulo: 'MSAM' },
    { valor: 'BLPARTS', rotulo: 'BL Parts' },
];

export default function Despacho() {
    const userString = window.localStorage.getItem("user");
    const user = JSON.parse(userString);

    const [allProducts, setAllProducts] = useState([]);
    const [pendingProducts, setPendingProducts] = useState([]);
    const [problemProducts, setProblemProducts] = useState([]);
    const [verifiedProducts, setVerifiedProducts] = useState([]);
    const [processedProducts, setProcessedProducts] = useState([]);
    const [shippedProducts, setShippedProducts] = useState([]);
    const [etapaAtual, setEtapaAtual] = useState(() => {
        const saved = window.localStorage.getItem('despacho_etapa');
        return saved === 'processamento' || saved === 'recebimento' ? saved : 'recebimento';
    });
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [isNfeModalOpen, setIsNfeModalOpen] = useState(false);
    const [modalInitialTab, setModalInitialTab] = useState(0);
    const [bulkAction, setBulkAction] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isConfirmMarkOpen, setIsConfirmMarkOpen] = useState(false);
    const [productToMark, setProductToMark] = useState(null);
    const [entradaProblemaProduct, setEntradaProblemaProduct] = useState(null);
    const [imagemDivergenteProducts, setImagemDivergenteProducts] = useState([]);
    const [corrigirImagemProduct, setCorrigirImagemProduct] = useState(null);
    const canDarEntradaEstoque = user?.tipo === 1 || user?.tipo === 3;

    const [searchTerm, setSearchTerm] = useState('');
    const [scannerOpen, setScannerOpen] = useState(false);
    // Multiplos modos de envio ao mesmo tempo (#2418). Lista vazia = todos.
    const [filterModoEnvio, setFilterModoEnvio] = useState([]);
    // Multiplas origens ao mesmo tempo (#2418). Lista vazia = todas.
    const [filterOrigem, setFilterOrigem] = useState([]);

    const [canceladasBusca, setCanceladasBusca] = useState([]);
    const [canceladasHoje, setCanceladasHoje] = useState([]);
    const [canceladasHojeSearch, setCanceladasHojeSearch] = useState('');
    const [anteciparVendaId, setAnteciparVendaId] = useState(null);

    const [selectedProduct, setSelectedProduct] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isOverdueOpen, onToggle: onOverdueToggle } = useDisclosure();
    const searchSectionRef = useRef(null);
    const searchInputRef = useRef(null);

    const [textObs, setTextObs] = useState("");
    const toast = useToast();
    const { confirm, ConfirmPortal } = useConfirm();

    const handleChangeTextObs = (event) => {
        setTextObs(event.target.value);
    };

    const handleAddObs = async (idVenda, texto, files) => {
        if (texto.length === 0 && files && files.length == 0) {
            toast({
                title: `ERRO: Digite uma Observação!`,
                status: 'error',
                isClosable: true,
            });
            return false;
        }

        const formData = new FormData();

        formData.append("id", idVenda);
        formData.append("id_user", user.id);
        formData.append("obs", texto);

        files.forEach((file, index) => {
            formData.append(`files[]`, file);
        });

        setIsLoading(true);
        try {
            const response = await criarObsVenda(formData);
            if (response !== false) {
                toast({
                    title: `Observação adicionada com sucesso!`,
                    status: 'success',
                    isClosable: true,
                });

                const now = new Date();
                const createdAt = now.toISOString();
                const observacaoNew = {
                    id: response.observacao_id,
                    arquivos: response.arquivos,
                    observacao: texto,
                    usuario_id: user.id,
                    created_at: createdAt,
                };
                setAllProducts((prevProducts) =>
                    prevProducts.map((produto) => {
                        if (produto.vendaId === idVenda) {
                            return {
                                ...produto,
                                observacoes: [...(produto.observacoes || []), observacaoNew],
                            };
                        }
                        return produto;
                    })
                );
                setSelectedProduct((prevSelected) => {
                    if (prevSelected && prevSelected.vendaId === idVenda) {
                        return {
                            ...prevSelected,
                            observacoes: [...(prevSelected.observacoes || []), observacaoNew],
                        };
                    }
                    return prevSelected;
                });
            } else {
                toast({
                    title: `Erro ao adicionar observação.`,
                    status: 'error',
                    isClosable: true,
                });
            }
            setIsLoading(false);
        } catch {
            toast({
                title: `Erro ao adicionar observação.`,
                status: 'error',
                isClosable: true,
            });
            setIsLoading(false);
        }
    };

    const handleApagarObs = (idVenda, idObs) => {
        setIsLoading(true);
        try {
            (async () => {
                const response = await apagarObsVenda(idObs);
                if (response != false) {
                    toast({
                        title: `Observação apagada com sucesso!`,
                        status: 'success',
                        isClosable: true,
                    });
                    setAllProducts((prevProducts) =>
                        prevProducts.map((produto) => {
                            if (produto.vendaId === idVenda) {
                                const obsIndex = (produto.observacoes || []).findIndex(obs => obs.id === idObs);
                                if (obsIndex !== -1) {
                                    const novasObs = [...produto.observacoes];
                                    novasObs.splice(obsIndex, 1);
                                    return { ...produto, observacoes: novasObs };
                                }
                            }
                            return produto;
                        })
                    );
                    setSelectedProduct((prevSelected) => {
                        if (prevSelected && prevSelected.vendaId === idVenda) {
                            const obsIndex = (prevSelected.observacoes || []).findIndex(obs => obs.id === idObs);
                            if (obsIndex !== -1) {
                                const novasObs = [...prevSelected.observacoes];
                                novasObs.splice(obsIndex, 1);
                                return { ...prevSelected, observacoes: novasObs };
                            }
                        }
                        return prevSelected;
                    });

                } else {
                    toast({
                        title: `Erro ao apagar observação.`,
                        status: 'error',
                        isClosable: true,
                    })
                }
                setIsLoading(false);
            })();
        }
        catch {
            toast({
                title: `Erro ao apagar observação.`,
                status: 'error',
                isClosable: true,
            })
            setIsLoading(false);
        }
    };

    const distributeProducts = useCallback((products) => {
        const pending = [];
        const problems = [];
        const verified = [];
        const processed = [];
        const shipped = [];

        products.forEach(product => {
            const status = product.verificationDetails?.status;
            if (status === 1 || status === 5) {
                verified.push(product);
            } else if (status === 2) {
                problems.push(product);
            } else if (status === 3) {
                processed.push(product);
            } else if (status === 4) {
                shipped.push(product);
            } else {
                pending.push(product);
            }
        });

        setPendingProducts(pending);
        setProblemProducts(problems);
        setVerifiedProducts(verified);
        setProcessedProducts(processed);
        setShippedProducts(shipped);
    }, []);

    const incompleteVendaIds = useMemo(() => {
        const incomplete = new Set();
        // Uma Venda está incompleta se QUALQUER produto dela não estiver verificado (status 1 ou 5) ou além
        allProducts.forEach(p => {
            const status = p.verificationDetails?.status;
            // Considerando 1=Verificado, 3=Processado, 4=Enviado, 5=Ressalva como status válidos e completos
            if (status !== 1 && status !== 3 && status !== 4 && status !== 5) {
                incomplete.add(p.vendaId);
            }
        });

        // Propagar incompletude para todas as vendas do mesmo pack:
        // se qualquer venda de um pack está incompleta, todas devem ser bloqueadas junto
        const packVendas = {};
        allProducts.forEach(p => {
            if (p.packId) {
                if (!packVendas[p.packId]) packVendas[p.packId] = new Set();
                packVendas[p.packId].add(p.vendaId);
            }
        });
        Object.values(packVendas).forEach(vendaIds => {
            if ([...vendaIds].some(vid => incomplete.has(vid))) {
                vendaIds.forEach(vid => incomplete.add(vid));
            }
        });

        return incomplete;
    }, [allProducts]);

    // Contagem de itens por venda e set de vendas com múltiplos itens
    const vendaItemCounts = useMemo(() => {
        const counts = {};
        allProducts.forEach(p => {
            counts[p.vendaId] = (counts[p.vendaId] || 0) + 1;
        });
        return counts;
    }, [allProducts]);

    const multiItemVendaIds = useMemo(() => {
        const multi = new Set();
        Object.entries(vendaItemCounts).forEach(([vendaId, count]) => {
            if (count > 1) multi.add(Number(vendaId));
        });
        return multi;
    }, [vendaItemCounts]);

    // Packs (KITs) com mais de um pedido vinculado: packId -> { count, orderIds }
    const kitPacks = useMemo(() => {
        const byPack = {};
        allProducts.forEach(p => {
            if (!p.packId) return;
            if (!byPack[p.packId]) byPack[p.packId] = new Map();
            if (!byPack[p.packId].has(p.vendaId)) {
                byPack[p.packId].set(p.vendaId, p.orderId || p.vendaId);
            }
        });
        const result = {};
        Object.entries(byPack).forEach(([packId, vendaMap]) => {
            if (vendaMap.size > 1) {
                result[packId] = { count: vendaMap.size, orderIds: [...vendaMap.values()] };
            }
        });
        return result;
    }, [allProducts]);

    const getVisibleSelectable = useCallback(() => {
        return [...verifiedProducts, ...processedProducts];
    }, [verifiedProducts, processedProducts]);

    const allVisibleSelected =
        (getVisibleSelectable().length > 0) &&
        (getVisibleSelectable().every(p => selectedProducts.some(sp => p.uniqueId === sp.uniqueId)));

    const someVisibleSelected = selectedProducts.length > 0 && !allVisibleSelected;

    // ===== SELEÇÃO POR COLUNA =====
    // Verified column
    const allVerifiedSelected =
        verifiedProducts.filter(p => !incompleteVendaIds.has(p.vendaId)).length > 0 &&
        verifiedProducts.filter(p => !incompleteVendaIds.has(p.vendaId)).every(p =>
            selectedProducts.some(sp => sp.uniqueId === p.uniqueId)
        );
    const someVerifiedSelected = selectedProducts.some(sp =>
        verifiedProducts.some(vp => vp.uniqueId === sp.uniqueId)
    ) && !allVerifiedSelected;

    const handleSelectAllVerified = (e) => {
        const selectableVerified = verifiedProducts.filter(p => !incompleteVendaIds.has(p.vendaId));
        if (e.target.checked) {
            setSelectedProducts(prev => {
                const existingIds = new Set(prev.map(p => p.uniqueId));
                const toAdd = selectableVerified.filter(p => !existingIds.has(p.uniqueId));
                return [...prev, ...toAdd];
            });
        } else {
            const verifiedIds = new Set(verifiedProducts.map(p => p.uniqueId));
            setSelectedProducts(prev => prev.filter(p => !verifiedIds.has(p.uniqueId)));
        }
    };

    // Processed (Embalados) column
    const allProcessedSelected =
        processedProducts.filter(p => !incompleteVendaIds.has(p.vendaId)).length > 0 &&
        processedProducts.filter(p => !incompleteVendaIds.has(p.vendaId)).every(p =>
            selectedProducts.some(sp => sp.uniqueId === p.uniqueId)
        );
    const someProcessedSelected = selectedProducts.some(sp =>
        processedProducts.some(pp => pp.uniqueId === sp.uniqueId)
    ) && !allProcessedSelected;

    const handleSelectAllProcessed = (e) => {
        const selectableProcessed = processedProducts.filter(p => !incompleteVendaIds.has(p.vendaId));
        if (e.target.checked) {
            setSelectedProducts(prev => {
                const existingIds = new Set(prev.map(p => p.uniqueId));
                const toAdd = selectableProcessed.filter(p => !existingIds.has(p.uniqueId));
                return [...prev, ...toAdd];
            });
        } else {
            const processedIds = new Set(processedProducts.map(p => p.uniqueId));
            setSelectedProducts(prev => prev.filter(p => !processedIds.has(p.uniqueId)));
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            // Exclui produtos de vendas incompletas do "Selecionar Todos"
            setSelectedProducts(getVisibleSelectable().filter(p => !incompleteVendaIds.has(p.vendaId)));
        } else {
            setSelectedProducts([]);
        }
    };

    const handleToggleSelectProduct = (product) => {
        const visible = getVisibleSelectable();
        const packId = product.packId;

        let groupProducts;
        if (packId) {
            groupProducts = visible.filter(p => p.packId === packId);
            const anyIncomplete = groupProducts.some(p => incompleteVendaIds.has(p.vendaId));
            if (anyIncomplete) return;
        } else {
            if (incompleteVendaIds.has(product.vendaId)) return;
            groupProducts = visible.filter(p => p.vendaId === product.vendaId);
        }

        setSelectedProducts(prev => {
            const isCurrentlySelected = prev.some(p => p.uniqueId === product.uniqueId);
            if (isCurrentlySelected) {
                if (packId) {
                    return prev.filter(p => p.packId !== packId);
                }
                return prev.filter(p => p.vendaId !== product.vendaId);
            }
            const existingIds = new Set(prev.map(p => p.uniqueId));
            const newProducts = groupProducts.filter(p => !existingIds.has(p.uniqueId));
            return [...prev, ...newProducts];
        });
    };

    // Move produtos embalados para a coluna "Processados"
    const handleMarkAsProcessed = useCallback(async (packedProducts) => {
        if (!packedProducts || packedProducts.length === 0) return;
        setIsLoading(true);

        try {
            const vendaIds = Array.from(new Set(packedProducts.map(p => p.vendaId)));
            const res = await concluirEmbalagemDespacho(vendaIds);

            if (res) {
                const packedIds = new Set(packedProducts.map(p => p.uniqueId));

                setAllProducts(prev => prev.map(p => {
                    if (packedIds.has(p.uniqueId)) {
                        return { ...p, verificationDetails: { ...p.verificationDetails, status: 3 } };
                    }
                    return p;
                }));

                setSelectedProducts([]);
                toast({ title: `${packedProducts.length} produto(s) movidos para Embalados!`, status: 'success', duration: 3000 });
            } else {
                toast({ title: "Erro", description: "Falha ao salvar embalagem no servidor.", status: 'error' });
            }
        } catch (error) {
            toast({ title: "Erro ao salvar embalagem no banco", status: 'error' });
        } finally {
            setIsLoading(false);
        }
    }, [toast]);

    // Desfaz (ou libera à mão) a retirada na loja de uma venda do site.
    // A liberação normal é automática, na conferência do último item. O cliente
    // só é avisado 5 minutos depois, então desmarcar dentro da janela cancela o
    // e-mail e o WhatsApp antes de saírem.
    const handleProntoRetirada = useCallback(async (product) => {
        const desfazer = !!product.prontoRetiradaAt;
        const pedido = product.orderId || product.vendaId;

        const ok = await confirm(desfazer
            ? {
                title: 'Desfazer pronto para retirada',
                body: product.clienteAvisadoRetirada
                    ? `O cliente do pedido ${pedido} JÁ FOI AVISADO de que a peça está pronta. Desfazer remove o aviso do site, mas o e-mail e o WhatsApp já enviados não voltam. Continuar?`
                    : `O pedido ${pedido} volta a aparecer como em separação e o aviso ao cliente não será enviado. Continuar?`,
                confirmText: 'Desfazer',
                confirmColor: 'red',
            }
            : {
                title: 'Liberar retirada na loja',
                body: `Confirma que as peças do pedido ${pedido} estão separadas? O cliente será avisado por e-mail e WhatsApp em 5 minutos. Dá para desfazer nesse intervalo.`,
                confirmText: 'Confirmar',
                confirmColor: 'green',
            });

        if (!ok) return;

        setIsLoading(true);
        const res = await marcarProntoRetiradaDespacho(product.vendaId, !desfazer);
        setIsLoading(false);

        if (!res.ok) {
            toast({ title: 'Não foi possível marcar', description: res.error, status: 'error', duration: 5000 });
            return;
        }

        // A liberação não embala mais a venda: o card fica onde está e quem
        // move para Embalados é o botão de concluir embalagem.
        setAllProducts(prev => prev.map(p => (
            p.vendaId !== product.vendaId
                ? p
                : { ...p, prontoRetiradaAt: res.prontoRetiradaAt || null, clienteAvisadoRetirada: !!res.clienteAvisado }
        )));

        toast({ title: res.message, status: 'success', duration: 5000 });
    }, [confirm, toast]);

    // Cliente retirou a peça no balcão: conclui a venda e dispara o aviso de
    // pedido entregue. Não tem como desfazer por aqui, só pela tela /vendas.
    const handleRetiradaColetada = useCallback(async (product) => {
        const pedido = product.orderId || product.vendaId;

        const ok = await confirm({
            title: 'Confirmar retirada pelo cliente',
            body: `O cliente retirou as peças do pedido ${pedido} no balcão? A venda é concluída e ele recebe o aviso de pedido entregue. Não dá para desfazer por esta tela.`,
            confirmText: 'Sim, cliente retirou',
            confirmColor: 'blue',
        });

        if (!ok) return;

        setIsLoading(true);
        const res = await marcarRetiradaColetadaDespacho(product.vendaId);
        setIsLoading(false);

        if (!res.ok) {
            toast({ title: 'Não foi possível concluir', description: res.error, status: 'error', duration: 5000 });
            return;
        }

        setAllProducts(prev => prev.map(p => p.vendaId === product.vendaId
            ? { ...p, retiradaColetada: true }
            : p));

        toast({ title: res.message, status: 'success', duration: 5000 });
    }, [confirm, toast]);

    // Reverte produtos embalados de volta para Verificados
    const handleRevertPacked = useCallback(async (products) => {
        if (!products || products.length === 0) return;
        setIsLoading(true);

        try {
            const vendaIds = Array.from(new Set(products.map(p => p.vendaId)));
            const res = await reverterEmbalagemDespacho(vendaIds);

            if (res) {
                const revertIds = new Set(products.map(p => p.uniqueId));

                setAllProducts(prev => prev.map(p => {
                    if (revertIds.has(p.uniqueId)) {
                        // Restaura o status anterior (5=ressalva ou 1=verificado).
                        // O backend guarda status_anterior_embalagem e restaura o original;
                        // aqui espelhamos essa lógica no estado local para UX imediata.
                        const statusRestaurado = p.verificationDetails?.statusAnterior || 1;
                        return {
                            ...p,
                            verificationDetails: {
                                ...p.verificationDetails,
                                status: statusRestaurado,
                                statusAnterior: null,
                            },
                        };
                    }
                    return p;
                }));

                toast({ title: `${products.length} produto(s) revertidos.`, status: 'info', duration: 3000 });
            } else {
                toast({ title: "Erro", description: "Falha ao reverter embalagem no servidor.", status: 'error' });
            }
        } catch (error) {
            toast({ title: "Erro ao reverter embalagem no banco", status: 'error' });
        } finally {
            setIsLoading(false);
        }
    }, [toast]);

    // Novo Handler: Marcar como Entregue (Retiradas / Combinar)
    const handleMarkAsDelivered = useCallback((product) => {
        if (!product) return;
        setProductToMark(product);
        setIsConfirmMarkOpen(true);
    }, []);

    const confirmMarkAsDelivered = async () => {
        if (!productToMark) return;
        const product = productToMark;
        setIsConfirmMarkOpen(false);
        setIsLoading(true);
        try {
            const success = await setStatusVenda(product.vendaId, 'concluida');
            if (success) {
                setAllProducts(prev => prev.map(p => {
                    if (p.vendaId === product.vendaId) {
                        return { ...p, verificationDetails: { ...p.verificationDetails, status: 4 } };
                    }
                    return p;
                }));
                toast({ title: "Venda concluída com sucesso!", status: 'success', duration: 3000 });
                onClose();
            } else {
                toast({ title: "Erro ao concluir venda", status: 'error' });
            }
        } catch (error) {
            toast({ title: "Erro de comunicação", status: 'error' });
        } finally {
            setIsLoading(false);
        }
    };


    // Processamento individual de uma venda via "etiqueta rápida"
    const handleProcessIndividual = useCallback((product) => {
        const packId = product.packId;
        const vendaId = product.vendaId;
        // Filtra todos os produtos do mesmo grupo (pack ou venda) visíveis e selecionáveis
        const allGroupProducts = allProducts.filter(p => {
            const sameGroup = packId ? p.packId === packId : p.vendaId === vendaId;
            return sameGroup &&
                ((p.verificationDetails?.status >= 1 && p.verificationDetails?.status < 4) || p.verificationDetails?.status === 5);
        });

        if (allGroupProducts.length === 0) return;

        // Seleciona os produtos e abre o modal
        setSelectedProducts(allGroupProducts);
        setModalInitialTab(0);
        setIsNfeModalOpen(true);
    }, [allProducts]);

    useEffect(() => {
        const fetchProducts = async () => {
            setIsLoading(true);
            const productsFromApi = await getProdutosParaConferencia();
            setAllProducts(productsFromApi);
            setIsLoading(false);
        };
        fetchProducts();
    }, []);

    useEffect(() => {
        getCanceladasDespacho({ modo: 'hoje' }).then(setCanceladasHoje);
    }, []);

    useEffect(() => {
        getImagensDivergentes().then(setImagemDivergenteProducts);
    }, []);

    useEffect(() => {
        if (searchTerm.trim().length >= 2) {
            getCanceladasDespacho({ modo: 'busca', search: searchTerm.trim() }).then(res => {
                setCanceladasBusca(res?.vendas || []);
            });
        } else {
            setCanceladasBusca([]);
        }
    }, [searchTerm]);

    const [buscaHojeResultado, setBuscaHojeResultado] = useState({ vendas: [], outras: [], ampliada: false });

    const canceladasHojeFiltradas = useMemo(() => {
        const termo = canceladasHojeSearch.trim().toLowerCase();
        if (!termo) return canceladasHoje;
        const termoLimpo = termo.replace(/^0+/, '') || '0';
        const match = (val) => {
            if (!val) return false;
            const s = String(val).toLowerCase();
            return s.includes(termo) || s.replace(/^0+/, '').includes(termoLimpo);
        };
        return canceladasHoje.filter(v => {
            if (match(v.venda_id) || match(v.id_origem) || match(v.pack_id) || match(v.cliente)) return true;
            return (v.itens || []).some(i =>
                match(i.nome) || match(i.global_code) || match(i.codigo_barra) || match(i.marca)
            );
        });
    }, [canceladasHoje, canceladasHojeSearch]);

    useEffect(() => {
        const termo = canceladasHojeSearch.trim();
        if (termo.length >= 2 && canceladasHojeFiltradas.length === 0) {
            getCanceladasDespacho({ modo: 'busca', search: termo, ampliar: 1 }).then(res => {
                setBuscaHojeResultado({
                    vendas: res?.vendas || [],
                    outras: res?.outras || [],
                    ampliada: !!res?.busca_ampliada,
                });
            });
        } else {
            setBuscaHojeResultado({ vendas: [], outras: [], ampliada: false });
        }
    }, [canceladasHojeSearch, canceladasHojeFiltradas]);

    const handleLinkLalamoveSalvo = useCallback((vendaId, link) => {
        setAllProducts(prev => prev.map(p => {
            if (p.vendaId !== vendaId) return p;
            return { ...p, envio: { ...(p.envio || {}), link_rastreio: link } };
        }));
    }, []);

    const handleCanceladaIncluida = () => {
        getImagensDivergentes().then(setImagemDivergenteProducts);
    };

    const resetScrollAndFocus = () => {
        setSearchTerm('');

        setTimeout(() => {
            if (searchSectionRef.current) {
                const posicaoElemento = searchSectionRef.current.getBoundingClientRect().top + window.scrollY;
                const ajusteFino = -80;
                window.scrollTo({
                    top: posicaoElemento + ajusteFino,
                    behavior: 'smooth'
                });
                setTimeout(() => {
                    searchInputRef.current?.focus();
                }, 100);
            }
        }, 400);
    };

    const shippingDeadlines = useMemo(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        let earliestToday = null;
        const overdueByDay = {};

        allProducts.forEach(product => {
            const envioDateStr = product.envio?.data_limite_envio;
            if (!envioDateStr) return;

            const envioDate = new Date(envioDateStr);
            const envioDay = new Date(envioDate);
            envioDay.setHours(0, 0, 0, 0);

            if (envioDay.getTime() === today.getTime()) {
                if (!earliestToday || envioDate < earliestToday) {
                    earliestToday = envioDate;
                }
            } else if (envioDay < today) {
                const key = envioDay.getTime();
                if (!overdueByDay[key]) {
                    overdueByDay[key] = { earliest: envioDate, orders: new Set() };
                }
                if (envioDate < overdueByDay[key].earliest) {
                    overdueByDay[key].earliest = envioDate;
                }
                const cleanId = String(product.orderId || '').replace('#', '');
                if (cleanId) overdueByDay[key].orders.add(cleanId);
            }
        });

        const overdueDays = Object.values(overdueByDay)
            .map(d => ({ earliest: d.earliest, orders: Array.from(d.orders) }))
            .sort((a, b) => b.earliest - a.earliest);

        const totalOverdue = overdueDays.reduce((acc, d) => acc + d.orders.length, 0);

        return {
            todayEarliest: earliestToday,
            overdueDays,
            totalOverdue
        };
    }, [allProducts]);

    const handleEtapaClick = (etapa) => {
        setEtapaAtual(etapa);
        window.localStorage.setItem('despacho_etapa', etapa);
    };

    const handleFiltrarPedido = (orderId) => {
        setSearchTerm(orderId);
        setTimeout(() => {
            if (searchSectionRef.current) {
                const posicaoElemento = searchSectionRef.current.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: posicaoElemento - 80, behavior: 'smooth' });
            }
        }, 100);
    };

    const etapa1Count = pendingProducts.length + problemProducts.length + verifiedProducts.length;
    const etapa2Count = verifiedProducts.length + processedProducts.length + shippedProducts.length;

    const formatDateTime = (dateObj) => {
        if (!dateObj) return '';
        return dateObj.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const availableShippingModes = useMemo(() => {
        const modes = new Set();
        allProducts.forEach(product => {
            modes.add(labelModoEnvio(product.envio));
        });
        return Array.from(modes).sort();
    }, [allProducts]);

    const filteredProducts = useMemo(() => {
        const trimmedSearch = searchTerm.trim().toLowerCase();
        const selectedModes = filterModoEnvio;
        const selectedOrigens = filterOrigem;

        if (!trimmedSearch && selectedModes.length === 0 && selectedOrigens.length === 0) {
            return allProducts;
        }

        const cleanSearchTerm = trimmedSearch.replace(/^0+/, '');
        const searchToUse = cleanSearchTerm === '' && trimmedSearch.length > 0 ? '0' : cleanSearchTerm;

        const checkMatch = (val) => {
            if (!val) return false;
            const str = String(val).toLowerCase();
            if (str.includes(trimmedSearch)) return true;
            const cleanVal = str.replace(/^0+/, '');
            return cleanVal.includes(searchToUse);
        };

        return allProducts.filter(product => {
            let textMatch = true;
            if (trimmedSearch) {
                const nameMatch = product.name?.toLowerCase().includes(trimmedSearch);
                const globalCodeMatch = checkMatch(product.globalCode);
                const supplierCodeMatch = checkMatch(product.produtoEstoque?.codigo_fornecedor);
                const fabrCodeMatch = checkMatch(product.produtoEstoque?.codigo_fabricante);
                const barcodeMatch = checkMatch(product.produtoEstoque?.codigo_barra);
                const packIdMatch = checkMatch(product.packId);
                const orderIdMatch = checkMatch(product.orderId);
                const idMatch = checkMatch(product.id);
                const vendaIdMatch = checkMatch(product.vendaId);

                textMatch = nameMatch || globalCodeMatch || idMatch || vendaIdMatch || packIdMatch || orderIdMatch || supplierCodeMatch || fabrCodeMatch || barcodeMatch;
            }

            let modeMatch = true;
            if (selectedModes.length > 0) {
                modeMatch = selectedModes.includes(labelModoEnvio(product.envio));
            }

            let originMatch = true;
            if (selectedOrigens.length > 0) {
                const isTaga = product.estoque_taga > 0;
                const fornecedor = product.fornecedor?.toUpperCase() || '';

                // Marcar varias soma as origens (Morelate OU Vannucci), que e o
                // que se espera de um filtro com checkbox. A cadeia de if/else
                // que existia aqui comparava exatamente isto, um por vez.
                originMatch = selectedOrigens.some(origem => (
                    origem === 'Estoque TAGA' ? isTaga : fornecedor === origem.toUpperCase()
                ));
            }

            return textMatch && modeMatch && originMatch;
        });
    }, [allProducts, searchTerm, filterModoEnvio, filterOrigem]);


    useEffect(() => {
        if (!isLoading) {
            distributeProducts(filteredProducts);
        }
    }, [filteredProducts, distributeProducts, isLoading]);

    useEffect(() => {
        if (!searchTerm.trim()) return;

        const visivelEmRecebimento = (p) => {
            const s = p.verificationDetails?.status;
            return s !== 3 && s !== 4;
        };
        const visivelEmProcessamento = (p) => {
            const s = p.verificationDetails?.status;
            return s === 1 || s === 5 || s === 3 || s === 4;
        };

        const visivelNaAtual = etapaAtual === 'recebimento' ? visivelEmRecebimento : visivelEmProcessamento;
        if (filteredProducts.some(visivelNaAtual)) return;

        const outraEtapa = etapaAtual === 'recebimento' ? 'processamento' : 'recebimento';
        const visivelNaOutra = outraEtapa === 'recebimento' ? visivelEmRecebimento : visivelEmProcessamento;
        if (filteredProducts.some(visivelNaOutra)) {
            setEtapaAtual(outraEtapa);
        }
    }, [searchTerm, filteredProducts, etapaAtual]);

    const handleOpenModal = (product) => {
        setSelectedProduct(product);
        onOpen();
    };

    const recarregarImagensDivergentes = useCallback(() => {
        getImagensDivergentes().then(setImagemDivergenteProducts);
    }, []);

    const handleEntradaEstoqueConfirmada = (product) => {
        setAllProducts(prev => prev.filter(p => p.vendaId !== product.vendaId));
        setEntradaProblemaProduct(null);
        recarregarImagensDivergentes();
        getCanceladasDespacho({ modo: 'hoje' }).then(setCanceladasHoje);
    };

    const recarregarProdutos = useCallback(async () => {
        const productsFromApi = await getProdutosParaConferencia();
        setAllProducts(productsFromApi);
    }, []);

    const handleCorrigirImagemConfirmada = () => {
        setCorrigirImagemProduct(null);
        recarregarProdutos();
        recarregarImagensDivergentes();
        getCanceladasDespacho({ modo: 'hoje' }).then(setCanceladasHoje);
    };

    const recarregarBuscaAmpliada = useCallback(() => {
        const termo = canceladasHojeSearch.trim();
        if (termo.length < 2) return;
        getCanceladasDespacho({ modo: 'busca', search: termo, ampliar: 1 }).then(res => {
            setBuscaHojeResultado({
                vendas: res?.vendas || [],
                outras: res?.outras || [],
                ampliada: !!res?.busca_ampliada,
            });
        });
    }, [canceladasHojeSearch]);

    const temResultadoNaBusca = canceladasHojeFiltradas.length > 0
        || buscaHojeResultado.vendas.length > 0
        || buscaHojeResultado.outras.length > 0;

    const handleAnteciparDespacho = useCallback(async (venda) => {
        const pedido = venda.id_origem || `#${venda.venda_id}`;

        const ok = await confirm({
            title: 'Antecipar despacho',
            body: venda.antecipa_no_canal
                ? `Confirma que a peça do pedido ${pedido} já está aqui na TAGA? O prazo de despacho passa para hoje. Se o envio ainda estiver retido pelo Mercado Livre, avisamos que o produto já está disponível para liberar a etiqueta, o que encurta o prazo prometido ao comprador e não dá para desfazer por esta tela.`
                : `Confirma que a peça do pedido ${pedido} já está aqui na TAGA? O prazo de despacho passa para hoje e a venda entra na gestão de despachos do dia.`,
            confirmText: 'Sim, antecipar',
            confirmColor: 'orange',
        });

        if (!ok) return;

        setAnteciparVendaId(venda.venda_id);
        const res = await anteciparDespachoVenda(venda.venda_id);
        setAnteciparVendaId(null);

        if (!res?.success) {
            toast({
                title: 'Não foi possível antecipar',
                description: res?.error || 'Erro desconhecido.',
                status: 'error',
                duration: 12000,
                isClosable: true,
            });
            return;
        }

        toast(res.liberacao_ml
            ? {
                title: `Mercado Livre só libera a etiqueta em ${res.liberacao_ml}`,
                description: `Prazo de despacho atualizado para ${res.prazo_novo}. A venda volta para a gestão de despachos nesse dia.`,
                status: 'warning',
                duration: 15000,
                isClosable: true,
            }
            : {
                title: `Despacho antecipado para ${res.prazo_novo}`,
                description: res.canal_avisado
                    ? 'Mercado Livre avisado de que o produto já está disponível. A venda entra na gestão de despachos do dia.'
                    : 'A venda já aparece na gestão de despachos do dia.',
                status: 'success',
                duration: 8000,
                isClosable: true,
            });

        recarregarProdutos();
        getCanceladasDespacho({ modo: 'hoje' }).then(setCanceladasHoje);
        recarregarBuscaAmpliada();
    }, [confirm, toast, recarregarProdutos, recarregarBuscaAmpliada]);

    const abrirAcaoDivergente = (item, acao) => {
        const produto = {
            id: item.produto_id,
            name: item.nome,
            globalCode: item.global_code,
            brand: item.marca,
            vendaId: item.venda_id,
            produtoEstoqueId: item.produto_estoque_id,
            quantity: item.quantidade,
            uniqueId: `divergente-${item.conferencia_id}`,
            verificationDetails: { status: 2, issues: { photo: true }, fotoCorrigidaAt: item.foto_corrigida_at },
        };
        if (acao === 'entrada') setEntradaProblemaProduct(produto);
        else setCorrigirImagemProduct(produto);
    };

    const abrirCorrigirImagemCancelada = (item, venda) => {
        setCorrigirImagemProduct({
            id: item.produto_id,
            name: item.nome,
            globalCode: item.global_code,
            brand: item.marca,
            vendaId: venda.venda_id,
            produtoEstoqueId: item.produto_estoque_id,
            uniqueId: `cancelada-${venda.venda_id}-${item.produto_estoque_id}`,
        });
    };

    const handleProductRevert = (revertedProduct) => {
        const updatedProducts = allProducts.map(p => {
            if (p.uniqueId === revertedProduct.uniqueId) {
                return { ...revertedProduct, verificationDetails: null };
            }
            return p;
        });

        setAllProducts(updatedProducts);

        resetScrollAndFocus();
    };

    const handleUpdateNotes = (vendaId, novasNotas) => {
        setAllProducts((prevProducts) =>
            prevProducts.map((p) => {
                if (p.vendaId === vendaId) {
                    return { ...p, observacoes: novasNotas };
                }
                return p;
            })
        );
    };

    const handleProductVerificationComplete = async (verifiedProduct, status) => {
        const payload = {
            vendaId: verifiedProduct.vendaId,
            produtoId: verifiedProduct.id,
            produtoEstoqueId: verifiedProduct.produtoEstoqueId,
            verificationDetails: verifiedProduct.verificationDetails,
            status: status,
        };

        const resultado = await salvarConferenciaProduto(payload);

        if (resultado) {
            const newStatus = status === 'success' ? 1 : (status === 'ressalva' ? 5 : 2);

            const updatedProducts = allProducts.map(p => {
                // Fechar a conferência da venda libera a retirada no backend:
                // pinta o badge RETIRADA na hora, sem recarregar a lista.
                const retirada = resultado.liberouRetirada && p.vendaId === verifiedProduct.vendaId
                    ? { prontoRetiradaAt: resultado.prontoRetiradaAt }
                    : null;

                if (p.uniqueId !== verifiedProduct.uniqueId) {
                    return retirada ? { ...p, ...retirada } : p;
                }
                return {
                    ...verifiedProduct,
                    ...retirada,
                    verificationDetails: {
                        ...verifiedProduct.verificationDetails,
                        status: newStatus
                    }
                };
            });

            setAllProducts(updatedProducts);

            resetScrollAndFocus();
        }
    };

    const hojeFormatado = new Date().toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });

    return (
        <>
            <ScrollToTop />
            <ConfirmPortal />
            {isLoading && <Preloader />}
            <Box textAlign="center" fontSize="xl" py={4} bg="white" minH="100vh">
                <Text color={"#F68633"} fontWeight={"bold"} mb={4}>
                    Gestão de Despachos
                </Text>

                <Box
                    mx={{ base: 1, md: 12, lg: 20 }}
                    mb={8}
                    p={4}
                    bg="gray.50"
                    borderRadius="lg"
                    borderWidth="1px"
                    borderColor="gray.200"
                    textAlign="left"
                >
                    <VStack spacing={4} align="stretch">
                        <HStack>
                            <Icon as={CalendarIcon} color="blue.500" w={6} h={6} />
                            <Text fontSize="lg" fontWeight="bold" color="gray.700">
                                Produtos para conferência de Despacho - HOJE ({hojeFormatado})
                            </Text>
                        </HStack>
                        <Text fontSize="sm" color="gray.600">
                            Esta tela exibe todos os pedidos com envio prioritário, incluindo aqueles com despacho para hoje e os que já estão atrasados, mas estão confirmados para serem enviados.
                        </Text>
                        <Divider />
                        <VStack spacing={3} align="stretch">
                            <HStack>
                                <Icon as={InfoOutlineIcon} color="blue.500" />
                                <Text fontSize="md" fontWeight="semibold" color="gray.700">Como Realizar a Conferência</Text>
                            </HStack>
                            <Text fontSize="sm" color="gray.600">
                                Para garantir a qualidade do envio, cada item deve ser cuidadosamente conferido. Verifique os seguintes pontos:
                            </Text>
                            <List spacing={2} pl={4} fontSize="sm">
                                <ListItem>
                                    <ListIcon as={CheckCircleIcon} color="green.500" />
                                    <strong>Imagem:</strong> Confira se o produto físico corresponde exatamente à imagem do anúncio (cor, modelo, peças inclusas, composições, etc.).
                                </ListItem>
                                <ListItem>
                                    <ListIcon as={CheckCircleIcon} color="green.500" />
                                    <strong>Marca e Código:</strong> Valide se a marca e o código global do produto são os mesmos que foram anunciados.
                                </ListItem>
                                <ListItem>
                                    <ListIcon as={CheckCircleIcon} color="green.500" />
                                    <strong>Nome:</strong> Verifique se o nome do produto está de acordo com o que foi recebido. Por exemplo: se o anúncio menciona "Kit", "Conjunto" ou "Par", certifique-se de que vieram todas as unidades correspondentes. Da mesma forma, se o nome indica, por exemplo, que é o para-choque completo, mas o item recebido representa apenas uma parte da composição, isso deve ser observado.
                                </ListItem>
                                <ListItem>
                                    <ListIcon as={CheckCircleIcon} color="green.500" />
                                    <strong>Quantidade:</strong> Ao informar a quantidade conferida, o sistema indicará automaticamente se houve divergência, como itens a mais ou a menos do que o esperado.
                                </ListItem>
                            </List>
                            <Text fontSize="sm" color="gray.600" pt={2}>
                                Para registrar, clique no item, insira a quantidade, valide as informações e, se houver problemas, relate-os. Em seguida, clique em <strong>"Confirmar"</strong>. Caso necessário, adicione detalhes no campo de observações.
                            </Text>

                            <Box pt={3} pl={1}>
                                {shippingDeadlines.todayEarliest && (
                                    <HStack spacing={2} mb={2}>
                                        <Icon as={TimeIcon} color="red.600" w={5} h={5} />
                                        <Text fontSize="sm" fontWeight="bold" color="red.600" textTransform="uppercase">
                                            HORÁRIO DO PRAZO DE ENVIO MAIS CEDO: {formatDateTime(shippingDeadlines.todayEarliest)}
                                        </Text>
                                    </HStack>
                                )}

                                {shippingDeadlines.overdueDays.length > 0 && (
                                    <Box mt={2}>
                                        <HStack
                                            as="button"
                                            onClick={onOverdueToggle}
                                            w="100%"
                                            spacing={2}
                                            bg="orange.100"
                                            _hover={{ bg: 'orange.200' }}
                                            borderRadius="md"
                                            px={3}
                                            py={2}
                                        >
                                            <Icon as={WarningIcon} color="orange.500" w={3} h={3} />
                                            <Text fontSize="xs" fontWeight="bold" color="orange.700" textTransform="uppercase">
                                                Pedidos atrasados
                                            </Text>
                                            <Badge colorScheme="orange" borderRadius="full" fontSize="0.65rem">
                                                {shippingDeadlines.totalOverdue} {shippingDeadlines.totalOverdue === 1 ? 'pedido' : 'pedidos'}
                                            </Badge>
                                            <Spacer />
                                            <Icon
                                                as={ChevronDownIcon}
                                                color="orange.600"
                                                w={4}
                                                h={4}
                                                transform={isOverdueOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
                                                transition="transform 0.2s"
                                            />
                                        </HStack>
                                        <Collapse in={isOverdueOpen} animateOpacity>
                                            <VStack align="stretch" spacing={2} pl={1} mt={2}>
                                        {shippingDeadlines.overdueDays.map((dia, index) => (
                                            <Box
                                                key={index}
                                                bg="orange.50"
                                                borderLeft="3px solid"
                                                borderColor="orange.400"
                                                borderRadius="md"
                                                px={3}
                                                py={2}
                                            >
                                                <HStack spacing={2} mb={1} flexWrap="wrap">
                                                    <Icon as={WarningIcon} color="orange.500" w={3} h={3} />
                                                    <Text fontSize="xs" fontWeight="bold" color="orange.700">
                                                        ATRASADO: {formatDateTime(dia.earliest)}
                                                    </Text>
                                                    <Badge colorScheme="orange" borderRadius="full" fontSize="0.65rem">
                                                        {dia.orders.length} {dia.orders.length === 1 ? 'pedido' : 'pedidos'}
                                                    </Badge>
                                                </HStack>
                                                <Flex wrap="wrap" gap={1.5} pl={5}>
                                                    {dia.orders.map(orderId => (
                                                        <Text
                                                            key={orderId}
                                                            as="button"
                                                            onClick={() => handleFiltrarPedido(orderId)}
                                                            fontSize="0.7rem"
                                                            fontWeight="medium"
                                                            color="orange.700"
                                                            bg="orange.100"
                                                            _hover={{ bg: 'orange.200' }}
                                                            borderRadius="md"
                                                            px={2}
                                                            py={0.5}
                                                            transition="background 0.15s"
                                                        >
                                                            {orderId}
                                                        </Text>
                                                    ))}
                                                </Flex>
                                            </Box>
                                        ))}
                                            </VStack>
                                        </Collapse>
                                    </Box>
                                )}
                            </Box>

                        </VStack>
                    </VStack>
                </Box>

                <Box mx={{ base: 1, md: 12, lg: 20 }} boxShadow='md' borderRadius="lg" px={0} mb={"10"} pb={2} overflowX="hidden">

                    <Box ref={searchSectionRef} px={{ base: 4, md: 6 }} py={4}>
                        <Flex direction={{ base: 'column', md: 'row' }} gap={4}>
                            <InputGroup flex={1}>
                                <InputLeftElement pointerEvents="none">
                                    <SearchIcon color="gray.400" />
                                </InputLeftElement>
                                <Input
                                    ref={searchInputRef}
                                    placeholder="Buscar por ID, Pack ID, Nome do Produto, Cód. Global..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    bg="white"
                                    focusBorderColor="orange.300"
                                    pr="3rem"
                                />
                                {searchTerm && (
                                    <InputRightElement>
                                        <IconButton
                                            aria-label="Limpar busca"
                                            icon={<CloseIcon />}
                                            size="sm"
                                            isRound
                                            variant="ghost"
                                            onClick={() => setSearchTerm('')}
                                        />
                                    </InputRightElement>
                                )}
                            </InputGroup>

                            <Button
                                leftIcon={<Icon as={FaCamera} />}
                                colorScheme="orange"
                                onClick={() => setScannerOpen(true)}
                                flexShrink={0}
                                display={{ base: 'flex', md: 'none' }}
                            >
                                Escanear
                            </Button>

                            <FiltroMultiplo
                                rotuloTodos="Todas as Origens"
                                opcoes={ORIGENS_DESPACHO}
                                selecionados={filterOrigem}
                                onChange={setFilterOrigem}
                            />

                            <FiltroMultiplo
                                rotuloTodos="Todos os Modos de Envio"
                                opcoes={availableShippingModes}
                                selecionados={filterModoEnvio}
                                onChange={setFilterModoEnvio}
                            />
                        </Flex>
                    </Box>

                    {/* <Grid mx={2} my={4} templateColumns={{ base: 'minmax(0, 1fr)', lg: 'repeat(3, minmax(0, 1fr))' }} gap={8} w="100%"> */}
                    {/* <Grid mx={{ base: 2, lg: 6 }} my={4} templateColumns={{ base: 'minmax(0, 1fr)', lg: 'repeat(3, minmax(0, 1fr))' }} gap={{ base: 6, lg: 8 }}>
                        <GridItem w="100%" overflow="hidden">
                            <OrderList
                                title={`Produtos para Conferência (${pendingProducts.length})`}
                                products={pendingProducts}
                                onOpenModal={handleOpenModal}
                                status="pending"
                                handleAddObs={handleAddObs}
                                handleChangeTextObs={handleChangeTextObs}
                                textObs={textObs}
                                handleApagarObs={handleApagarObs}
                            />
                        </GridItem>
                        <GridItem w="100%" overflow="hidden">
                            <OrderList
                                title={`Produtos com Problemas (${problemProducts.length})`}
                                products={problemProducts}
                                onOpenModal={handleOpenModal}
                                status="problem"
                                handleAddObs={handleAddObs}
                                handleChangeTextObs={handleChangeTextObs}
                                textObs={textObs}
                                handleApagarObs={handleApagarObs}
                            />
                        </GridItem>
                        <GridItem w="100%" overflow="hidden">
                            <OrderList
                                title={`Produtos Verificados (${verifiedProducts.length})`}
                                products={verifiedProducts}
                                onOpenModal={handleOpenModal}
                                status="verified"
                                handleAddObs={handleAddObs}
                                handleChangeTextObs={handleChangeTextObs}
                                textObs={textObs}
                                handleApagarObs={handleApagarObs}
                            />
                        </GridItem>
                    </Grid> */}

                    <Flex justify="center" mb={4} mt={2} px={2}>
                        <ButtonGroup
                            isAttached
                            variant="outline"
                            bg="white"
                            size={{ base: 'sm', md: 'md' }}
                            w={{ base: '100%', md: 'auto' }}
                        >
                            <Button
                                colorScheme={etapaAtual === 'recebimento' ? 'orange' : 'gray'}
                                isActive={etapaAtual === 'recebimento'}
                                onClick={() => { handleEtapaClick('recebimento'); setSelectedProducts([]); }}
                                flex={{ base: 1, md: 'initial' }}
                                px={{ base: 2, md: 8 }}
                                fontSize={{ base: 'xs', md: 'sm' }}
                                whiteSpace="nowrap"
                            >
                                <Box as="span" display={{ base: 'none', md: 'inline' }}>Etapa 1: Recebimento ({etapa1Count})</Box>
                                <Box as="span" display={{ base: 'inline', md: 'none' }}>Etapa 1 ({etapa1Count})</Box>
                            </Button>
                            <Button
                                colorScheme={etapaAtual === 'processamento' ? 'green' : 'gray'}
                                isActive={etapaAtual === 'processamento'}
                                onClick={() => handleEtapaClick('processamento')}
                                flex={{ base: 1, md: 'initial' }}
                                px={{ base: 2, md: 8 }}
                                fontSize={{ base: 'xs', md: 'sm' }}
                                whiteSpace="nowrap"
                            >
                                <Box as="span" display={{ base: 'none', md: 'inline' }}>Etapa 2: Processamento ({etapa2Count})</Box>
                                <Box as="span" display={{ base: 'inline', md: 'none' }}>Etapa 2 ({etapa2Count})</Box>
                            </Button>
                        </ButtonGroup>
                    </Flex>

                    {etapaAtual === 'processamento' && (
                        <Box
                            bg="white"
                            p={{ base: 3, md: 4 }}
                            borderRadius="lg"
                            mb={4}
                            mx={{ base: 2, lg: 6 }}
                            borderWidth="1px"
                            borderColor="gray.200"
                            position="sticky"
                            top="0"
                            zIndex={10}
                            boxShadow="sm"
                        >
                            <Flex direction={{ base: 'column', md: 'row' }} justify="space-between" align={{ base: 'stretch', md: 'center' }} gap={3}>
                                <Checkbox
                                    isChecked={allVisibleSelected}
                                    isIndeterminate={someVisibleSelected}
                                    onChange={handleSelectAll}
                                    colorScheme="blue"
                                >
                                    <Text fontSize={{ base: 'xs', md: 'sm' }}>Selecionar Todos ({getVisibleSelectable().length})</Text>
                                </Checkbox>

                                <Flex direction={{ base: 'column', sm: 'row' }} gap={2} align={{ base: 'stretch', sm: 'center' }}>
                                    <Text fontSize="xs" color="gray.600" whiteSpace="nowrap">
                                        {selectedProducts.length} selecionados
                                    </Text>
                                    <Select size="sm" w={{ base: '100%', sm: '240px' }} placeholder="Selecione uma ação" bg="white" value={bulkAction} onChange={(e) => setBulkAction(e.target.value)}>
                                        <option value="emitir">Processamento completo</option>
                                        <option value="processar_nfe">Processar NFes</option>
                                        <option value="processar_etiquetas">Processar Etiquetas</option>
                                        <option value="processar_controle">Processar Controle</option>
                                    </Select>
                                    <Button size="sm" colorScheme="blue" isDisabled={selectedProducts.length === 0 || !bulkAction} onClick={() => {
                                        if (bulkAction === 'emitir') {
                                            setModalInitialTab(0);
                                            setIsNfeModalOpen(true);
                                        } else if (bulkAction === 'processar_nfe') {
                                            setModalInitialTab(0);
                                            setIsNfeModalOpen(true);
                                        } else if (bulkAction === 'processar_etiquetas') {
                                            setModalInitialTab(1);
                                            setIsNfeModalOpen(true);
                                        } else if (bulkAction === 'processar_controle') {
                                            setModalInitialTab(2);
                                            setIsNfeModalOpen(true);
                                        } else {
                                            toast({ title: 'Ação não implementada ainda', status: 'info' });
                                        }
                                    }}>
                                        Aplicar
                                    </Button>
                                </Flex>
                            </Flex>
                        </Box>
                    )}

                    {etapaAtual === 'recebimento' ? (
                        <>
                        <Grid mx={{ base: 2, lg: 6 }} my={4} templateColumns={{ base: 'minmax(0, 1fr)', lg: 'repeat(3, minmax(0, 1fr))' }} gap={{ base: 6, lg: 8 }}>
                            <GridItem w="100%" overflow="hidden">
                                <OrderList
                                    title={`Produtos para Conferência (${pendingProducts.length})`}
                                    products={pendingProducts}
                                    onOpenModal={handleOpenModal}
                                    status="pending"
                                    handleAddObs={handleAddObs}
                                    handleChangeTextObs={handleChangeTextObs}
                                    textObs={textObs}
                                    handleApagarObs={handleApagarObs}
                                    etapaAtual={etapaAtual}
                                    vendaItemCounts={vendaItemCounts}
                                    multiItemVendaIds={multiItemVendaIds}
                                    kitPacks={kitPacks}
                                />
                            </GridItem>
                            <GridItem w="100%" overflow="hidden">
                                <OrderList
                                    title={`Produtos com Problemas (${problemProducts.length})`}
                                    products={problemProducts}
                                    onOpenModal={handleOpenModal}
                                    status="problem"
                                    handleAddObs={handleAddObs}
                                    handleChangeTextObs={handleChangeTextObs}
                                    textObs={textObs}
                                    handleApagarObs={handleApagarObs}
                                    etapaAtual={etapaAtual}
                                    vendaItemCounts={vendaItemCounts}
                                    multiItemVendaIds={multiItemVendaIds}
                                    kitPacks={kitPacks}
                                    onDarEntradaEstoque={canDarEntradaEstoque ? setEntradaProblemaProduct : undefined}
                                />
                            </GridItem>
                            <GridItem w="100%" overflow="hidden">
                                <OrderList
                                    title={`Produtos Verificados (${verifiedProducts.length})`}
                                    products={verifiedProducts}
                                    onOpenModal={handleOpenModal}
                                    status="verified"
                                    handleAddObs={handleAddObs}
                                    handleChangeTextObs={handleChangeTextObs}
                                    textObs={textObs}
                                    handleApagarObs={handleApagarObs}
                                    etapaAtual={etapaAtual}
                                    vendaItemCounts={vendaItemCounts}
                                    multiItemVendaIds={multiItemVendaIds}
                                    kitPacks={kitPacks}
                                    onProcessIndividual={handleProcessIndividual}
                                    onCorrigirImagem={canDarEntradaEstoque ? setCorrigirImagemProduct : undefined}
                                />
                            </GridItem>
                        </Grid>
                        <SecaoImagemDivergente
                            itens={imagemDivergenteProducts}
                            onDarEntrada={(item) => abrirAcaoDivergente(item, 'entrada')}
                            onCorrigirImagem={(item) => abrirAcaoDivergente(item, 'corrigir')}
                        />
                        </>
                    ) : (
                        <Grid mx={{ base: 2, lg: 6 }} my={4} templateColumns={{ base: 'minmax(0, 1fr)', lg: 'repeat(3, minmax(0, 1fr))' }} gap={{ base: 6, lg: 8 }}>
                            <GridItem w="100%" overflow="hidden">
                                <OrderList
                                    title={`Produtos Verificados (${verifiedProducts.length})`}
                                    products={verifiedProducts}
                                    onOpenModal={handleOpenModal}
                                    status="verified"
                                    handleAddObs={handleAddObs}
                                    handleChangeTextObs={handleChangeTextObs}
                                    textObs={textObs}
                                    handleApagarObs={handleApagarObs}
                                    etapaAtual={etapaAtual}
                                    isSelectable={true}
                                    selectedProducts={selectedProducts}
                                    onToggleSelect={handleToggleSelectProduct}
                                    vendaItemCounts={vendaItemCounts}
                                    multiItemVendaIds={multiItemVendaIds}
                                    kitPacks={kitPacks}
                                    incompleteVendaIds={incompleteVendaIds}
                                    onProcessIndividual={handleProcessIndividual}
                                    onLinkLalamoveSalvo={handleLinkLalamoveSalvo}
                                    onProntoRetirada={handleProntoRetirada}
                                    groupMode={true}
                                    columnSelectAll={{
                                        isChecked: allVerifiedSelected,
                                        isIndeterminate: someVerifiedSelected,
                                        onChange: handleSelectAllVerified,
                                        count: verifiedProducts.filter(p => !incompleteVendaIds.has(p.vendaId)).length
                                    }}
                                />
                            </GridItem>
                            <GridItem w="100%" overflow="hidden">
                                <OrderList
                                    title={`Produtos Embalados (${processedProducts.length})`}
                                    products={processedProducts}
                                    onOpenModal={handleOpenModal}
                                    status="processed"
                                    handleAddObs={handleAddObs}
                                    handleChangeTextObs={handleChangeTextObs}
                                    textObs={textObs}
                                    handleApagarObs={handleApagarObs}
                                    etapaAtual={etapaAtual}
                                    isSelectable={true}
                                    selectedProducts={selectedProducts}
                                    onToggleSelect={handleToggleSelectProduct}
                                    vendaItemCounts={vendaItemCounts}
                                    multiItemVendaIds={multiItemVendaIds}
                                    kitPacks={kitPacks}
                                    incompleteVendaIds={incompleteVendaIds}
                                    onProcessIndividual={handleProcessIndividual}
                                    onLinkLalamoveSalvo={handleLinkLalamoveSalvo}
                                    onProntoRetirada={handleProntoRetirada}
                                    groupMode={true}
                                    columnSelectAll={{
                                        isChecked: allProcessedSelected,
                                        isIndeterminate: someProcessedSelected,
                                        onChange: handleSelectAllProcessed,
                                        count: processedProducts.filter(p => !incompleteVendaIds.has(p.vendaId)).length
                                    }}
                                />
                            </GridItem>
                            <GridItem w="100%" overflow="hidden">
                                <OrderList
                                    title={`Produtos Enviados (${shippedProducts.length})`}
                                    products={shippedProducts}
                                    onOpenModal={handleOpenModal}
                                    status="shipped"
                                    handleAddObs={handleAddObs}
                                    handleChangeTextObs={handleChangeTextObs}
                                    textObs={textObs}
                                    handleApagarObs={handleApagarObs}
                                    etapaAtual={etapaAtual}
                                    vendaItemCounts={vendaItemCounts}
                                    multiItemVendaIds={multiItemVendaIds}
                                    kitPacks={kitPacks}
                                    onProcessIndividual={handleProcessIndividual}
                                    onLinkLalamoveSalvo={handleLinkLalamoveSalvo}
                                    groupMode={true}
                                />
                            </GridItem>
                        </Grid>
                    )}

                    {etapaAtual === 'recebimento' && canceladasBusca.length > 0 && (
                        <Box mx={{ base: 2, lg: 6 }} mt={4}>
                            <Text fontSize="sm" fontWeight="semibold" color="red.600" mb={3}>
                                Vendas canceladas encontradas na busca
                            </Text>
                            <VStack spacing={3} align="stretch">
                                {canceladasBusca.map(v => (
                                    <CardVendaCancelada key={v.venda_id} venda={v} userId={user.id} onIncluido={handleCanceladaIncluida} onCorrigirImagem={canDarEntradaEstoque ? abrirCorrigirImagemCancelada : undefined} />
                                ))}
                            </VStack>
                        </Box>
                    )}

                    {selectedProduct && (
                        <ConfirmationModalDespacho
                            isOpen={isOpen}
                            onClose={onClose}
                            productToVerify={selectedProduct}
                            onConfirm={handleProductVerificationComplete}
                            onRevert={handleProductRevert}
                            onUpdateNotes={handleUpdateNotes}
                            handleAddObs={handleAddObs}
                            handleChangeTextObs={handleChangeTextObs}
                            textObs={textObs}
                            handleApagarObs={handleApagarObs}
                            etapaAtual={etapaAtual}
                            user={user}
                            onProcessIndividual={handleProcessIndividual}
                            incompleteVendaIds={incompleteVendaIds}
                            onMarkAsDelivered={handleMarkAsDelivered}
                            onDarEntradaEstoque={canDarEntradaEstoque ? setEntradaProblemaProduct : undefined}
                            onCorrigirImagem={canDarEntradaEstoque ? setCorrigirImagemProduct : undefined}
                        />
                    )}

                    <EntradaEstoqueProblemaModal
                        isOpen={!!entradaProblemaProduct}
                        onClose={() => setEntradaProblemaProduct(null)}
                        product={entradaProblemaProduct}
                        userId={user?.id}
                        onConfirmed={handleEntradaEstoqueConfirmada}
                    />

                    <CorrigirImagemModal
                        isOpen={!!corrigirImagemProduct}
                        onClose={() => setCorrigirImagemProduct(null)}
                        product={corrigirImagemProduct}
                        userId={user?.id}
                        onConfirmed={handleCorrigirImagemConfirmada}
                    />

                    <BarcodeScanner
                        isOpen={scannerOpen}
                        onClose={() => setScannerOpen(false)}
                        onDetected={(codigo) => {
                            setScannerOpen(false);
                            setSearchTerm(codigo);
                        }}
                    />

                    <ModalEmitirNfeDespacho
                        isOpen={isNfeModalOpen}
                        onClose={() => setIsNfeModalOpen(false)}
                        selectedProducts={selectedProducts}
                        incompleteVendaIds={incompleteVendaIds}
                        onRemoveItem={handleToggleSelectProduct}
                        onMarkAsProcessed={handleMarkAsProcessed}
                        onRevertPacked={handleRevertPacked}
                        onProntoRetirada={handleProntoRetirada}
                        onRetiradaColetada={handleRetiradaColetada}
                        initialTab={modalInitialTab}
                        onProcessComplete={(produtosEmitted) => {
                            setSelectedProducts([]);
                        }}
                    />

                    {/* MODAL DE CONFIRMAÇÃO DE ENTREGA (PREMIUM) */}
                    <Modal isOpen={isConfirmMarkOpen} onClose={() => setIsConfirmMarkOpen(false)} isCentered size="md">
                        <ModalOverlay backdropFilter="blur(8px) hue-rotate(90deg)" bg="blackAlpha.700" />
                        <ModalContent rounded="2xl" shadow="2xl" borderWidth="1px" borderColor="purple.100">
                            <ModalHeader bg="purple.500" color="white" roundedTop="2xl" py={4}>
                                <HStack spacing={3}>
                                    <Icon as={CheckCircleIcon} boxSize={6} />
                                    <Text fontSize="xl" fontWeight="extrabold">Confirmar Entrega</Text>
                                </HStack>
                            </ModalHeader>
                            <ModalCloseButton color="white" />
                            <ModalBody py={8}>
                                <VStack spacing={4}>
                                    <Box bg="purple.50" p={4} rounded="full">
                                        <Icon as={CheckCircleIcon} boxSize={12} color="purple.500" />
                                    </Box>
                                    <VStack spacing={1} textAlign="center">
                                        <Text fontSize="lg" color="gray.700">Deseja marcar a venda <Text as="span" fontWeight="bold" color="purple.600">#{productToMark?.orderId?.replace('#','')}</Text> como <Text as="span" fontWeight="bold" color="green.600">ENTREGUE</Text>?</Text>
                                        <Text fontSize="sm" color="gray.500">Esta ação moverá o pedido para a coluna de enviados e concluirá a venda no sistema.</Text>
                                    </VStack>
                                </VStack>
                            </ModalBody>
                            <ModalFooter bg="gray.50" roundedBottom="2xl" gap={3}>
                                <Button variant="ghost" onClick={() => setIsConfirmMarkOpen(false)} fontWeight="normal">Cancelar</Button>
                                <Button colorScheme="purple" size="lg" px={8} onClick={confirmMarkAsDelivered} shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-1px)' }}>
                                    Confirmar Entrega
                                </Button>
                            </ModalFooter>
                        </ModalContent>
                    </Modal>
                </Box>

                <Box mx={{ base: 1, md: 12, lg: 20 }} mb={8} mt={4}>
                    <Box borderWidth="1px" borderColor={canceladasHoje.length > 0 ? 'red.200' : 'gray.200'} borderRadius="lg" overflow="hidden">
                        <Box bg={canceladasHoje.length > 0 ? 'red.500' : 'gray.600'} px={4} py={3}>
                            <HStack spacing={2}>
                                <Icon as={canceladasHoje.length > 0 ? WarningIcon : SearchIcon} color="white" />
                                <Text color="white" fontWeight="bold" fontSize="sm">
                                    {canceladasHoje.length > 0
                                        ? `Vendas Canceladas: Previstas para Despacho Hoje (${canceladasHojeFiltradas.length}${canceladasHojeSearch ? ` de ${canceladasHoje.length}` : ''})`
                                        : 'Consultar venda e antecipar despacho'}
                                </Text>
                            </HStack>
                        </Box>
                        <Box px={4} pt={4} bg="white">
                            <InputGroup size="sm" maxW="480px">
                                <InputLeftElement pointerEvents="none">
                                    <SearchIcon color="gray.400" />
                                </InputLeftElement>
                                <Input
                                    placeholder="Filtrar por venda, cliente, produto, SKU, global, código..."
                                    value={canceladasHojeSearch}
                                    onChange={(e) => setCanceladasHojeSearch(e.target.value)}
                                    bg="white"
                                    focusBorderColor={canceladasHoje.length > 0 ? 'red.300' : 'orange.300'}
                                    pr="3rem"
                                />
                                {canceladasHojeSearch && (
                                    <InputRightElement>
                                        <IconButton
                                            aria-label="Limpar busca"
                                            icon={<CloseIcon />}
                                            size="xs"
                                            isRound
                                            variant="ghost"
                                            onClick={() => setCanceladasHojeSearch('')}
                                        />
                                    </InputRightElement>
                                )}
                            </InputGroup>
                        </Box>
                        <VStack spacing={3} align="stretch" p={4} bg="white">
                            {canceladasHojeFiltradas.map(v => (
                                <CardVendaCancelada key={v.venda_id} venda={v} userId={user.id} onIncluido={handleCanceladaIncluida} onCorrigirImagem={canDarEntradaEstoque ? abrirCorrigirImagemCancelada : undefined} />
                            ))}

                            {canceladasHojeFiltradas.length === 0 && buscaHojeResultado.vendas.length > 0 && (
                                <>
                                    <Box bg="orange.50" borderWidth="1px" borderColor="orange.200" borderRadius="md" px={3} py={2}>
                                        <Text fontSize="sm" color="orange.700">
                                            Venda cancelada encontrada fora da janela das últimas 24h.
                                        </Text>
                                    </Box>
                                    {buscaHojeResultado.vendas.map(v => (
                                        <CardVendaCancelada key={v.venda_id} venda={v} userId={user.id} onIncluido={handleCanceladaIncluida} onCorrigirImagem={canDarEntradaEstoque ? abrirCorrigirImagemCancelada : undefined} />
                                    ))}
                                </>
                            )}

                            {buscaHojeResultado.outras.length > 0 && (
                                <>
                                    <Box bg="blue.50" borderWidth="1px" borderColor="blue.200" borderRadius="md" px={3} py={2}>
                                        <Text fontSize="sm" color="blue.700">
                                            Outras vendas encontradas para essa busca, em qualquer status. As que estão em aberto com prazo futuro podem ter o despacho antecipado.
                                        </Text>
                                    </Box>
                                    {buscaHojeResultado.outras.map(v => (
                                        <CardVendaOutroStatus
                                            key={v.venda_id}
                                            venda={v}
                                            onAntecipar={handleAnteciparDespacho}
                                            anteciparLoading={anteciparVendaId === v.venda_id}
                                        />
                                    ))}
                                </>
                            )}

                            {temResultadoNaBusca ? null : !canceladasHojeSearch.trim() ? (
                                <Text fontSize="sm" color="gray.500" textAlign="center" py={4}>
                                    Nenhuma venda cancelada prevista para despacho hoje. Busque acima pela venda cujo item já chegou para antecipar o despacho.
                                </Text>
                            ) : (
                                <Text fontSize="sm" color="gray.500" textAlign="center" py={4}>
                                    {buscaHojeResultado.ampliada
                                        ? `Nenhuma venda encontrada para "${canceladasHojeSearch}" em nenhum status`
                                        : `Nenhuma venda encontrada para "${canceladasHojeSearch}"`}
                                </Text>
                            )}
                        </VStack>
                    </Box>
                </Box>
            </Box>
        </>
    );
};